module.exports = __webpack_public_path__ + "img/hr-red-croton-02.30169423.png";